<template>
  <div
    :class="{
      flex: true,
      'px-6': true,
      'pt-5': true,
      'container-small': small
    }"
  >
    <div class="flex-3 left-min-w">
      <div class="mt-0">
        <span class="text-medium text-black text-opacity-85">
          <span class="mr-1">自定义标题</span>
        </span>
        <el-input
          class="mt-3"
          size="small"
          placeholder="请输入"
          v-model="shareOtherSetting.title"
          @blur="titleBlurHandle"
          :readonly="!isAdmin"
        />
      </div>
      <div class="mt-6">
        <span class="text-medium text-black text-opacity-85">
          <span class="mr-1">自定义描述</span>
        </span>
        <el-input
          class="mt-3"
          type="textarea"
          placeholder="请输入"
          :autosize="{ minRows: small ? 2 : 3, maxRows: small ? 2 : 3 }"
          resize="none"
          v-model="shareOtherSetting.desc"
          @blur="descBlurHandle"
          :readonly="!isAdmin"
        />
      </div>
      <div class="mt-2">
        <p class="text-yellow-theme text-xs leading-18">
          <i class="el-icon-warning-outline text-orange-600"></i>
          严禁发布诱导分享、诱导关注、欺诈、谣言、广告及垃圾信息、低俗信息等违法违规信息内容。一经发现，封号处理。
        </p>
        <div class="mt-3 flex">
          <div class="flex flex-col items-center" v-if="shareText">
            <vue-qr :logo-src="logoSrc" :text="shareText" :margin="5" :size="600" style="width: 88px; height: 88px" />
            <p class="mt-2 w-full text-center text-small text-black text-opacity-65">微信扫码分享</p>
          </div>
        </div>
      </div>
    </div>
    <div class="share-line float-left"></div>
    <div class="flex-1 preview-share-box mt-0">
      <div class="mt-0">
        <span class="text-medium text-black text-opacity-85">分享给好友预览</span>
        <div class="share-view-box bg-f7 flex mt-3">
          <div class="friend-box text-base">
            <div class="share-title truncate text-small">
              {{ shareOtherSetting.title || defaultTitle }}
            </div>
            <div class="preview-content flex">
              <div class="share-desc text-small">
                {{ shareOtherSetting.desc }}
              </div>
              <img class="share-icon" :src="linkLogoSrc" alt="icon" />
            </div>
            <div class="triangle"></div>
          </div>
          <div class="share-avatar" :style="backgroundImage"></div>
        </div>
      </div>
      <div class="mt-6">
        <span class="text-medium text-black text-opacity-85">分享到朋友圈预览</span>
        <div class="share-view-box bg-f7 flex text-base mt-3">
          <div class="share-avatar mr-1" :style="backgroundImage"></div>
          <div>
            <span class="text-small">微信昵称</span>
            <div class="friends-preview-box">
              <img class="share-icon" :src="linkLogoSrc" alt="icon" />
              <div class="share-title text-small truncate box-border pr-3">
                {{ shareOtherSetting.title || defaultTitle }}
              </div>
            </div>
            <div class="preview-time flex justify-between">
              <span class="text-small text-gray-500">1分钟前</span>
              <i>
                <span data-v-51147192="" class="svg-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="11" viewBox="0 0 22 11">
                    <g fill="none" fill-rule="evenodd">
                      <rect width="22" height="11" fill="#E9E9E9" rx="2"></rect>
                      <circle cx="7.5" cy="5.5" r="1.5" fill="#5A698C"></circle>
                      <circle cx="14.5" cy="5.5" r="1.5" fill="#5A698C"></circle>
                    </g>
                  </svg>
                </span>
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import GlobalConfig from '@/global/config'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import { defaultDescs } from '@/global/config-variable'
import { logo } from '@/assets/js/logo'
export default {
  name: 'WxShare',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    shareText: {
      type: String,
      default: ''
    },
    wjDetail: {
      type: Object,
      default: () => ({})
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueQr
  },
  data() {
    const desc = defaultDescs[(Math.random() * defaultDescs.length) | 0]
    const qusTitle = this.$store.getters.title
    const defaultTitle = qusTitle || '请填写问卷调查标题'
    return {
      logoSrc: logo().logoSrc,
      linkLogoSrc: logo().linkLogoSrc,
      defaultTitle,
      detail: {
        title: defaultTitle,
        desc,
        icon: ''
      },
      shareOtherSetting: {
        title: defaultTitle,
        desc,
        icon: ''
      }
    }
  },
  watch: {
    wjDetail: {
      deep: true,
      immediate: true,
      handler(obj) {
        if (obj) {
          this.setDetailByProps()
        }
      }
    }
  },
  methods: {
    setDetailByProps() {
      this.detail.title = this.wjDetail.title || this.defaultTitle || ''
      this.detail.desc = this.wjDetail.desc ?? this.detail.desc
      this.detail.icon = this.wjDetail.icon ?? ''
      this.shareOtherSetting.title = this.wjDetail.title || this.defaultTitle || ''
      this.shareOtherSetting.desc = this.wjDetail.desc ?? this.detail.desc
      this.shareOtherSetting.icon = this.wjDetail.icon ?? ''
    },
    titleBlurHandle() {
      const { title } = this.shareOtherSetting
      if (title !== this.detail.title) {
        this.setDetail()
      }
    },
    descBlurHandle() {
      const { desc } = this.shareOtherSetting
      if (desc !== this.detail.desc) {
        this.setDetail()
      }
    },
    setDetail() {
      const { title, desc, icon } = this.shareOtherSetting
      const params = {
        id: GlobalConfig.getSurveyId(),
        otherSetting: {
          shareOtherSetting: { title, desc, icon }
        }
      }
      saveSurveySetting(params)
        .then(() => {
          // this.$message.success('修改成功');
          this.wjDetail.title = title
          this.wjDetail.desc = desc
          this.wjDetail.icon = icon
        })
        .catch(e => {
          this.$message.error(e.msg || '修改分享信息失败')
        })
    }
  },
  computed: {
    backgroundImage() {
      return { backgroundImage: `url(${this.logoSrc})` }
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-border-none {
  border: none !important;
}

.share-line {
  margin: 0 20px;
  border-left: 1px solid #eaeaea;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.share-avatar {
  width: 30px;
  height: 30px;
  background: no-repeat 50%;
  background-size: 100% auto;
  margin-left: 5px;
}

.preview-share-box {
  max-width: calc(100% - 41px);
}

.share-view-box {
  padding: 32px 18px;
  box-sizing: border-box;
  position: relative;

  .friend-box {
    @apply relative;
    width: 286px;
    box-sizing: border-box;
    padding: 17px;
    background: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
  }

  .friends-preview-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 58px;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    background: #fff;
  }

  .triangle {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #fff;
    z-index: 1;
    top: 14px;
    right: -4px;
    border-top: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    transform: rotate(45deg);
  }

  .share-title {
    width: 180px;
    height: 20px;
    margin-bottom: 6px;
  }

  .share-desc {
    width: 180px;
    height: 36px;
    line-height: 18px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 12px;
    color: #aaa;
  }

  .share-icon {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 0 10px;
  }
}

.container-small {
  .left-min-w {
    min-width: 53.524%;
  }
  .share-view-box {
    @apply px-4 py-4;
    .friend-box {
      width: auto;
    }
    .share-title,
    .share-desc {
      max-width: 135px;
    }
    .triangle {
      right: 47px;
    }
  }
}
</style>
